class PageUseful {
  constructor() {
    this.selectors = {
      component: '.pageUseful',
      closeFormButton: '#close-form',
      toggleFormButton: '#toggle-form',
      formContainer: '.pageUseful__form-wrapper',
      formArea: '.pageUseful__form',
      submitButton: '.pageUseful__form button[type="submit"]',
      thankyouMessage: '.pageUseful__thankYou',
      quickReplyButton: '.button-quickReply',
    };
  }

  toggleForm() {
    $(this.selectors.toggleFormButton).on('click', (event) => {
      $(this.selectors.formContainer).slideToggle();
      $(event.currentTarget).toggleClass('pageUseful__form-open');
    });
  }

  closeForm() {
    $(this.selectors.closeFormButton).on('click', () => {
      $(this.selectors.formContainer).slideUp();
      $(this.selectors.toggleFormButton).removeClass('pageUseful__form-open');

      this.scrollToElementTop();
    });
  }

  scrollToElementTop() {
    setTimeout(() => {
      const offset = -400;
      const yScroll = document.querySelector(this.selectors.component)
        .getBoundingClientRect().top + window.pageYOffset + offset;
      window.scrollTo({
        top: yScroll,
        left: 0,
        behavior: 'smooth',
      });
    }, 200);
  }

  // to be completed based on BE requirements
  handleSubmit() {
    $(this.selectors.submitButton).on('click', () => {
      // When form is ok to submit.
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (!mutation.addedNodes) {
            return;
          }

          for (let i = 0; i < mutation.addedNodes.length; i += 1) {
            const node = mutation.addedNodes[i];

            if ($(node).hasClass('formwidget-submit-text')) {
              $('.formwidget-submit-text').hide();
              $('.pageUseful__form-wrapper').show();
              $('.pageUseful__form').hide();
              $('.pageUseful__thankYou').show();
              this.scrollToElementTop();
            }
          }
        });
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: false,
        characterData: false,
      });
    });

    $(this.selectors.quickReplyButton).on('click', (event) => {
      event.preventDefault();

      const dataObj = {
        PageUrl: window.location.href,
        Value: $(event.currentTarget).val(),
      };

      $.ajax({
        url: '/T2U/UsefulPage',
        type: 'POST',
        dataType: 'JSON',
        data: { json: JSON.stringify(dataObj) },
      })
        .always(() => {
          $('.pageUseful__form-wrapper').show();
          $('.pageUseful__form').hide();
          $('.pageUseful__thankYou').show();
        });
    });
  }

  init() {
    this.toggleForm();
    this.closeForm();
    this.handleSubmit();
  }
}

export default new PageUseful();
